export const data3_2_1 = [{
    name: '',
    name_code: '',
    outlets: '0',
    seats: '0',
    available: '0',
    covers: '0',
    turn_over: '0',
    revenue: '0',
    AC: '0',
    revpas: '0',
    toi: '0',
    toi_ranking: '0',
    ACI: '0',
    ACI_ranking: '0',
    RGI: '0',
    RGI_ranking: '0',
}, {
    name: '',
    name_code: '',
    outlets: '0',
    seats: '0',
    available: '0',
    covers: '0',
    turn_over: '0',
    revenue: '0',
    AC: '0',
    revpas: '0',
    toi: '0',
    toi_ranking: '0',
    ACI: '0',
    ACI_ranking: '0',
    RGI: '0',
    RGI_ranking: '0',
}, {
    name: '',
    name_code: '',
    outlets: '0',
    seats: '0',
    available: '0',
    covers: '0',
    turn_over: '0',
    revenue: '0',
    AC: '0',
    revpas: '0',
    toi: '0',
    toi_ranking: '0',
    ACI: '0',
    ACI_ranking: '0',
    RGI: '0',
    RGI_ranking: '0',
}, {
    name: '',
    name_code: '',
    outlets: '0',
    seats: '0',
    available: '0',
    covers: '0',
    turn_over: '0',
    revenue: '0',
    AC: '0',
    revpas: '0',
    toi: '0',
    toi_ranking: '0',
    ACI: '0',
    ACI_ranking: '0',
    RGI: '0',
    RGI_ranking: '0',
}, {
    name: '',
    name_code: '',
    outlets: '0',
    seats: '0',
    available: '0',
    covers: '0',
    turn_over: '0',
    revenue: '0',
    AC: '0',
    revpas: '0',
    toi: '0',
    toi_ranking: '0',
    ACI: '0',
    ACI_ranking: '0',
    RGI: '0',
    RGI_ranking: '0',
}, {
    name: 'Total',
    name_code: 'Total',
    outlets: '0',
    seats: '0',
    available: '0',
    covers: '0',
    turn_over: '0',
    revenue: '0',
    AC: '0',
    revpas: '0',
    toi: '0',
    toi_ranking: '0',
    ACI: '0',
    ACI_ranking: '0',
    RGI: '0',
    RGI_ranking: '0',
}];




// WEBPACK FOOTER //
// ./src/components/table/3.0/3-3/data.js